import { useMemo, useState } from "react"
import { useFormikContext } from "formik"
import { Stack } from "@mui/material"

import { ConfigQuery, fetchMeetingServiceMessages, MeetingServiceMessagesResponse } from "../../../createOrderApi"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import { SelectedPriceListItem } from "../../../createOrderTypes"
import { MeetingServiceTabValues } from "../../form/formTypes"

import { sortMessagesByPriority } from "./helpers"
import { MessagesDialog } from "./MessagesDialog"
import { MessageCard } from "./MessageCard"

const selectBookingConfig = (data: MeetingServiceMessagesResponse) => data?.messages || []

export function Messages() {
    const { values } = useFormikContext<MeetingServiceTabValues>()
    const priceListItem: SelectedPriceListItem = values["priceList"]

    const { data: messages = [] } = useApiQuery(fetchMeetingServiceMessages, {
        queryName: ConfigQuery.MEETING_SERVICE_MESSAGES,
        dependencies: {
            merchantId: priceListItem.merchantId,
            priceListId: priceListItem.priceListId,
            shopId: priceListItem.shopId,
        },
        select: selectBookingConfig,
        enabled: !!priceListItem.merchantId && !!priceListItem.priceListId && !!priceListItem.shopId,
    })

    const [openModal, setOpenModal] = useState(false)

    const handleReadMore = () => setOpenModal(true)
    const handleClose = () => setOpenModal(false)

    const sortedMessages = useMemo(() => sortMessagesByPriority(messages), [messages])

    if (!messages.length) return null

    return (
        <>
            <Stack padding=".5rem 0">
                <Stack gap=".5rem">
                    {sortedMessages.map((message) => (
                        <MessageCard key={message.id} message={message} onClick={handleReadMore} />
                    ))}
                </Stack>
            </Stack>

            {openModal && <MessagesDialog messages={sortedMessages} onClose={handleClose} />}
        </>
    )
}
